import axios from 'axios';

const FreshcallerCallService = {
  async getFreshcallerCalls(email) {
    const response = await axios.get('/freshcaller_call', {
      params: {
        email,
      },
    });

    return response.data;
  },

  async getFreshcallerCallRecording({ callId, recordingId }) {
    const response = await axios.get(
      `/freshcaller_call/${callId}/recording/${recordingId}`
    );

    return response.data;
  },

  async getUnassociatedFreshcallerCalls({ page, limit }) {
    const response = await axios.get('/freshcaller_call/unassociated', {
      params: {
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async updateFreshcallerCall({ callId, borrowerId, excludeFromLog }) {
    const response = await axios.put(`/freshcaller_call/${callId}`, {
      borrower_id: borrowerId,
      exclude_from_log: excludeFromLog,
    });

    return response.data;
  },
};

export default FreshcallerCallService;
